<template>
    <section-container title="Itens do Checklist" icon="clipboard-check">
        <div class="additionals-list">
            <!-- Itera sobre todos os itens do checklist -->
            <div
                v-for="checklistItem in selectedItems"
                :key="checklistItem.id"
                class="additional-item"
                :class="{ 'has-reason': !checklistItem.status && checklistItem.reason_not_ok && checklistItem.reason_not_ok.trim() !== '' }"
            >
                <div class="item-content">
                    <div class="additional-name">
                        {{ checklistItem.description.description }}
                    </div>

                    <!-- Status do item com ícone -->
                    <div class="additional-status">
                        <template v-if="checklistItem.status">
                            <span class="status-indicator-reserve active">
                                <i class="fas fa-check-circle"></i>
                            </span>
                        </template>
                        <template v-else>
                            <span class="status-indicator-reserve">
                                <i class="fas fa-times-circle"></i>
                            </span>
                        </template>
                    </div>
                </div>

                <!-- Mostra a razão apenas quando status for false E reason_not_ok estiver preenchido -->
                <div
                    v-if="!checklistItem.status && checklistItem.reason_not_ok && checklistItem.reason_not_ok.trim() !== ''"
                    class="reason-container"
                >
                    <div class="reason-label">
                        <i class="fas fa-exclamation-triangle"></i>
                        Motivo:
                    </div>
                    <div class="reason-text">
                        {{ checklistItem.reason_not_ok }}
                    </div>
                </div>
            </div>

            <!-- Mensagem quando não há itens -->
            <div v-if="!selectedItems || selectedItems.length === 0" class="no-items">
                <i class="fas fa-info-circle"></i>
                Nenhum item do checklist encontrado.
            </div>
        </div>
    </section-container>
</template>

<script>
import SectionContainer from './SectionContainer.vue';

export default {
    name: "AdditionalItems",
    components: {
        SectionContainer
    },
    props: {
        selectedItems: { // itens_checklist - array com os itens do checklist
            type: Array,
            default: () => []
        }
    }
};
</script>

<style scoped>
.additionals-list {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.additional-item {
    display: flex;
    flex-direction: column;
    padding: 0.75rem 1rem;
    background: white;
    border-bottom: 1px solid #e2e8f0;
    transition: background-color 0.2s ease;
}

.additional-item:hover {
    background: #f7fafc;
}

.additional-item:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.additional-item:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom: none;
}

.item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.additional-name {
    font-weight: 500;
    color: #4a5568;
    font-size: 0.95rem;
}

.additional-status {
    display: flex;
    align-items: center;
}

.status-indicator-reserve {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.status-indicator-reserve i {
    font-size: 1.2rem;
    color: #cbd5e0;
}

 .status-indicator-reserve i {
     color: #e53e3e;
 }

.status-indicator-reserve.active i {
    color: #48bb78;
}

.reason-container {
    background: #fff5f5;
    border: 1px solid #feb2b2;
    border-radius: 6px;
    padding: 0.75rem;
    margin-top: 0.75rem;
    width: 100%;
}

.reason-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    color: #742a2a;
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
}

.reason-label i {
    color: #e53e3e;
}

.reason-text {
    color: #742a2a;
    font-size: 0.9rem;
    line-height: 1.4;
    background: white;
    padding: 0.5rem;
    border-radius: 4px;
    border: 1px solid #fbb6ce;
}

.no-items {
    text-align: center;
    padding: 2rem;
    color: #718096;
    font-style: italic;
}

.no-items i {
    margin-right: 0.5rem;
    color: #a0aec0;
}

@media (max-width: 768px) {
    .additional-item {
        padding: 0.65rem 0.75rem;
    }

    .additional-name {
        font-size: 0.9rem;
    }

    .item-content {
        flex-direction: row;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/AdditionalItems.vue